var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHonduras(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#55bbe0",
    d: "M0 24V0h30v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55bbe0",
    d: "m8.28 8.77-.3.93H7l.8.57-.31.93.79-.57.79.57-.3-.93.79-.57h-.98zm.3 4.96-.3-.93-.3.93H7l.8.57-.31.93.79-.57.79.57-.3-.93.79-.57zm6.72-2.02-.3-.93-.3.93h-.98l.8.58-.31.93.79-.58.79.58-.3-.93.79-.58zm5.93-1.44-.3.93.79-.57.79.57-.3-.93.79-.57h-.98l-.3-.93-.3.93h-.98zm.8 3.46-.31-.93-.3.93h-.98l.8.57-.31.93.79-.57.79.57-.3-.93.79-.57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonduras);
export default __webpack_public_path__ + "static/media/honduras.74e852db5c965554422d245b163e9b15.svg";
export { ForwardRef as ReactComponent };